export const TEMPLATES: Record<number, string> = {
  0: 'Simple IVR',
  1: 'DTMF',
  2: 'Call Patch',
  3: 'Custom IVR',
  4: 'Multi IVR',
  6: 'Inbound Call Patch',
  7: 'TTS Simple IVR',
  8: 'TTS DTMF',
  9: 'TTS Call Patch',
};

export const DTMF_KEYS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '#'] as const;
export type DtmfKey = (typeof DTMF_KEYS)[number];

export const IVR_SETTING_ORDER = ['answer', 'play', 'gather', 'record', 'hangup'] as const;
